import { NgModule } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import warningFilled from '@cigna/leaf-icons/lib/icons/system/fill/warning.svg';
import account from '@cigna/leaf-icons/lib/icons/system/regular/account.svg';
import download from '@cigna/leaf-icons/lib/icons/system/regular/download.svg';
import edit from '@cigna/leaf-icons/lib/icons/system/regular/edit.svg';
import refresh from '@cigna/leaf-icons/lib/icons/system/regular/refresh.svg';
import visibilityFalse from '@cigna/leaf-icons/lib/icons/system/regular/visibility-false.svg';
import visibilityTrue from '@cigna/leaf-icons/lib/icons/system/regular/visibility-true.svg';
import warning from '@cigna/leaf-icons/lib/icons/system/regular/warning.svg';
import flagFilled from '@phosphor-icons/core/assets/fill/flag-fill.svg';
import flagRegular from '@phosphor-icons/core/assets/regular/flag.svg';
import favoriteEmpty from '@cigna/leaf-icons/lib/icons/system/regular/favorite-empty.svg';
import favoriteFull from '@cigna/leaf-icons/lib/icons/system/regular/favorite-full.svg';
import downloadSimple from '@phosphor-icons/core/assets/regular/download-simple.svg';
import error from '@cigna/leaf-icons/lib/icons/system/regular/error.svg';
import errorFilled from '@cigna/leaf-icons/lib/icons/system/fill/error.svg';
import success from '@cigna/leaf-icons/lib/icons/system/regular/success.svg';
import info from '@cigna/leaf-icons/lib/icons/system/regular/info.svg';
import infoFilled from '@cigna/leaf-icons/lib/icons/system/fill/info.svg';
import externalLink from '@cigna/leaf-icons/lib/icons/system/regular/external-link.svg';
import help from '@cigna/leaf-icons/lib/icons/system/regular/help.svg';
import search from '@cigna/leaf-icons/lib/icons/system/regular/search.svg';
import print from '@cigna/leaf-icons/lib/icons/system/regular/print.svg';
import calendar from '@cigna/leaf-icons/lib/icons/system/regular/calendar.svg';
import trash from '@cigna/leaf-icons/lib/icons/system/regular/trash.svg';
import warningCircle from '@phosphor-icons/core/assets/regular/warning-circle.svg';
import pdf from '@cigna/leaf-icons/lib/icons/system/regular/file-pdf.svg';
import file from '@cigna/leaf-icons/lib/icons/system/regular/file.svg';
import userPlus from '@phosphor-icons/core/assets/regular/user-plus.svg';
import usersThree from '@phosphor-icons/core/assets/regular/users-three.svg';

@NgModule({
  imports: [MatIconModule],
  exports: [MatIconModule],
})
export class ChcpSharedLeafIconsUiModule {
  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    iconRegistry.addSvgIconLiteral(
      'leaf-system-regular-visibility-true',
      sanitizer.bypassSecurityTrustHtml(visibilityTrue as string),
    );
    iconRegistry.addSvgIconLiteral(
      'leaf-system-regular-visibility-false',
      sanitizer.bypassSecurityTrustHtml(visibilityFalse as string),
    );
    iconRegistry.addSvgIconLiteral(
      'leaf-system-regular-warning',
      sanitizer.bypassSecurityTrustHtml(warning as string),
    );
    iconRegistry.addSvgIconLiteral(
      'leaf-system-filled-warning',
      sanitizer.bypassSecurityTrustHtml(warningFilled as string),
    );
    iconRegistry.addSvgIconLiteral(
      'leaf-system-regular-account',
      sanitizer.bypassSecurityTrustHtml(account as string),
    );
    iconRegistry.addSvgIconLiteral(
      'phosphor-regular-flag',
      sanitizer.bypassSecurityTrustHtml(flagRegular as string),
    );
    iconRegistry.addSvgIconLiteral(
      'phosphor-fill-flag',
      sanitizer.bypassSecurityTrustHtml(flagFilled as string),
    );
    iconRegistry.addSvgIconLiteral(
      'leaf-system-regular-error',
      sanitizer.bypassSecurityTrustHtml(error as string),
    );
    iconRegistry.addSvgIconLiteral(
      'leaf-system-filled-error',
      sanitizer.bypassSecurityTrustHtml(errorFilled as string),
    );
    iconRegistry.addSvgIconLiteral(
      'leaf-system-regular-success',
      sanitizer.bypassSecurityTrustHtml(success as string),
    );
    iconRegistry.addSvgIconLiteral(
      'leaf-system-regular-info',
      sanitizer.bypassSecurityTrustHtml(info as string),
    );
    iconRegistry.addSvgIconLiteral(
      'leaf-system-filled-info',
      sanitizer.bypassSecurityTrustHtml(infoFilled as string),
    );
    iconRegistry.addSvgIconLiteral(
      'leaf-system-regular-external-link',
      sanitizer.bypassSecurityTrustHtml(externalLink as string),
    );
    iconRegistry.addSvgIconLiteral(
      'leaf-system-regular-help',
      sanitizer.bypassSecurityTrustHtml(help as string),
    );
    iconRegistry.addSvgIconLiteral(
      'leaf-system-regular-pdf',
      sanitizer.bypassSecurityTrustHtml(pdf as string),
    );
    iconRegistry.addSvgIconLiteral(
      'leaf-system-regular-file',
      sanitizer.bypassSecurityTrustHtml(file as string),
    );
    iconRegistry.addSvgIconLiteral(
      'leaf-system-regular-search',
      sanitizer.bypassSecurityTrustHtml(search as string),
    );
    iconRegistry.addSvgIconLiteral(
      'leaf-system-regular-print',
      sanitizer.bypassSecurityTrustHtml(print as string),
    );
    iconRegistry.addSvgIconLiteral(
      'leaf-system-regular-calendar',
      sanitizer.bypassSecurityTrustHtml(calendar as string),
    );
    iconRegistry.addSvgIconLiteral(
      'leaf-system-regular-download',
      sanitizer.bypassSecurityTrustHtml(download as string),
    );
    iconRegistry.addSvgIconLiteral(
      'leaf-system-regular-refresh',
      sanitizer.bypassSecurityTrustHtml(refresh as string),
    );
    iconRegistry.addSvgIconLiteral(
      'leaf-system-regular-edit',
      sanitizer.bypassSecurityTrustHtml(edit as string),
    );
    iconRegistry.addSvgIconLiteral(
      'leaf-system-favorite-empty',
      sanitizer.bypassSecurityTrustHtml(favoriteEmpty as string),
    );
    iconRegistry.addSvgIconLiteral(
      'leaf-system-favorite-full',
      sanitizer.bypassSecurityTrustHtml(favoriteFull as string),
    );
    iconRegistry.addSvgIconLiteral(
      'phosphor-regular-download-simple',
      sanitizer.bypassSecurityTrustHtml(downloadSimple as string),
    );
    iconRegistry.addSvgIconLiteral(
      'leaf-system-regular-trash',
      sanitizer.bypassSecurityTrustHtml(trash as string),
    );
    iconRegistry.addSvgIconLiteral(
      'phosphor-regular-warning-circle',
      sanitizer.bypassSecurityTrustHtml(warningCircle as string),
    );
    iconRegistry.addSvgIconLiteral(
      'phosphor-regular-user-plus',
      sanitizer.bypassSecurityTrustHtml(userPlus as string),
    );
    iconRegistry.addSvgIconLiteral(
      'phosphor-regular-users-three',
      sanitizer.bypassSecurityTrustHtml(usersThree as string),
    );
  }
}
